/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react plugin used to create charts
import './enduser-home.css';




// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Button

} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import {Categimages} from "variables/categimages";
import {Sapicon} from "variables/categimages";

import ModalForm from 'components/modal/modal'

import {NewOtherform} from '../components/TicketForms/Userformnewtkt'


class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      userReady: false,
      currentUser: { username: "" },
isOpen:false,
iscstmOpen:false,
isotherOpen:false,

category:'',
queue:''


    };
  }

  componentDidMount() {


    this.setState({ userReady: true });
   /* const currentUser = AuthService.getCurrentUser();

    if (!currentUser) this.setState({ redirect: "/login" });
    this.setState({ currentUser: currentUser, userReady: true })*/



  }




  openModal = () => this.setState({ isOpen: true });
  closeModal = () => {this.setState({ isOpen: false});window.location.reload()}

  opencstmModal = () => this.setState({ iscstmOpen: true });
  closecstmModal = () => {this.setState({ iscstmOpen: false});window.location.reload()}


  openotherModal = () => this.setState({ isotherOpen: true });
  closeotherModal = () => {this.setState({ isotherOpen: false});window.location.reload()}

handleCatgClick = (e) => {
  

  


  let gcatsandopmodal = new Promise((myResolve, myReject) =>{ 
  
    if ( e.target.id === 'SAP') { this.setState({queue: e.target.id})}

    else {this.setState({queue: 'HelpDesk'})}



    this.setState({category: e.target.id})

  
        myResolve(e.target.id);
        myReject("Error");
      
  
  
  
  
    });
    
    gcatsandopmodal.then(
      (value)  =>{
        if (value !== 'SAP' && value !== 'other') {
        this.openModal()
      }else if (value === 'SAP'){this.opencstmModal()}

      else {this.openotherModal()}

      
      },
      (error)  =>{console.log(error);}
    );
    







}

  








  render() {

  /*  if (this.state.redirect) {
      return <Redirect to={this.state.redirect} /> }const { currentUser } = this.state;*/

const slice1st =  Categimages.slice(0, 5) 
const slice2nd =  Categimages.slice(5, 10) 

    const frstrow = slice1st.map(item => 
<Col xs={12} md={2} key={item.id}>
 <div className="catg" style={{ height: '180px' ,marginBottom:'50px' }} onClick= {this.handleCatgClick} >
     <CardHeader><CardTitle><strong>{item.id}</strong></CardTitle></CardHeader>
      <img  id={item.id} src={item.src} style={item.style} alt="Category" />
  </div>
</Col>)

const scndrow  = slice2nd.map(item => 
  <Col xs={12} md={2} key={item.id}>
   <div className="catg" style={{ height: '180px' ,marginBottom:'50px' }} onClick= {this.handleCatgClick} >
       <CardHeader><CardTitle><strong>{item.id}</strong></CardTitle></CardHeader>
        <img  id={item.id} src={item.src} style={item.style} />
    </div>
  </Col>)

    return (
      
      <>


            <div>
        {(this.state.userReady) ?

        <div>

        
        <PanelHeader
          size="sm"
          /*content={
<h2>How Can We Serve You?</h2>
          }*/
          
        />
        <div className="content">

                 
        { this.state.isOpen && this.state.userReady ? 
<Col xs={12} md={3}>
                 <ModalForm 
            closeModal={this.closeModal} 
            isOpen={this.state.isOpen} 
            title={"New " + this.state.category + " Ticket"}
            size="md"
          /></Col> :null}


{ this.state.iscstmOpen && this.state.userReady ? 
<Col xs={12} md={3}>
                 <ModalForm 
            closeModal={this.closecstmModal} 
            isOpen={this.state.iscstmOpen} 
            title={"New " + this.state.category + " Ticket"}
            size="md"
          /></Col> :null}


{ this.state.isotherOpen && this.state.userReady ? 
<Col xs={12} md={3}>
                 <ModalForm 
            closeModal={this.closeotherModal} 
            isOpen={this.state.isotherOpen} 
            title={"Please Give Us Detailed Description"}
            size="md"
          /></Col> :null}






        <Card  className="text-center">
        <CardHeader>
                  <CardTitle tag="h4">How Can We Serve You?</CardTitle>
                 </CardHeader>

                 <CardBody>

          <Row className="justify-content-center align-items-center" >
{frstrow}

          </Row>


          <Row className="justify-content-center align-items-center" >
{scndrow}


<Col xs={12} md={2} key={Sapicon.id}>
   <div className="catg" style={{ height: '180px' ,marginBottom:'50px' }} onClick= {this.handleCatgClick} >
       <CardHeader><CardTitle><strong>{Sapicon.id}</strong></CardTitle></CardHeader>
        <img  id={Sapicon.id} src={Sapicon.src} style={Sapicon.style} />
    </div>
  </Col>

          </Row>
<Row className="justify-content-center align-items-center"> 

<Button variant="contained" id="other" type="button" onClick={this.handleCatgClick} >
              Other
          </Button>

</Row>

</CardBody>
</Card>


          

        </div>



      </div>: null}
      </div>

      </>
    );
  }
}

export default Dashboard;
